export function DocLogo() {
  return <img src="/maxiron-invoice-logo.png" alt="Maxiron" className="doc-logo" />;
}
